<div class="container-fluid">
    <div class="card">
        <div class="d-flex flex-row justify-content-between form-group mt-2 mb-5">
            @if (isEcommerceAccount()) {
                <button (click)="back()" class="btn btn-standard action-btn" type="button">
                    <i class="fa fa-arrow-left"></i> Back
                </button>
            } @else {
                <div [hidden]="!getAccountStatusUtil().isPaymentOutstanding(account?.accountState) || !hasRouteAccess(routes.SECURE.ACCOUNT.EDIT)">
                    <button (click)="edit()" class="btn btn-standard action-btn" type="button">
                        <i class="fa fa-edit"></i> Edit
                    </button>
                </div>
            }
            <span></span>
            <div [hidden]="isEcommerceAccount()">
                <button (click)="back()" class="btn btn-standard action-btn" type="button">
                    <i class="fa fa-arrow-left"></i> Back
                </button>
            </div>
        </div>
        <div class="card-body text-center">

            <h2 class="d-inline">{{ account?.referenceNumber }} </h2>
            <h2 [ngClass]="getAccountStatusUtil().getAccountTextColorClass(account?.accountState) + ' !important'">
                {{ account?.accountState | getAccountStatusDescription }} </h2>
            <h2>Recipient: {{ account?.customer }}</h2>
            <h2>Amount: {{ getAmount(account) | toMajor | currency:'R' }}</h2>
            @if (account?.multiPremium) {
                <h3>Multi Premium Option: {{ account?.multiPremium }}</h3>
            }
            <h3 [hidden]="account?.dateTimeExpire == null">
                Expiry
                Date: {{ account?.dateTimeExpire  | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD HH:mm:ss' }} </h3>
            <div [hidden]="(account?.description == null || account?.description.length==0)">
                <h3>{{ account?.description }}</h3>
            </div>

            <div class="form-group  col-md-12">
                <table class="table table-hover table-responsive-md">
                    <thead>
                    <tr>
                        <th scope="col">Date</th>
                        <th scope="col">User</th>
                        <th scope="col">Description</th>
                    </tr>
                    </thead>
                    <tbody class="table-hover text-nowrap">
                        @for (auditLog of accountLogs; track auditLog) {
                            <tr>
                                <td>{{ auditLog.dateTimeCreated | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD HH:mm:ss' }}</td>
                                <td>{{ auditLog?.userName }}</td>
                                <td>{{ auditLog.description }}</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>